export const styles = (theme) => ({});

export const textFieldStyles = (theme) => ({
  actionForm: {
    // marginTop: '1rem'
  },
  label: {
    fontWeight: "500",
  },
  badge: {
    top: 1,
    width: "1.6rem",
    height: "1.6rem",
    borderRadius: "50%",
    // The border color match the background color.
    border: `2px solid ${
      theme.palette.type === "light"
        ? theme.palette.grey[200]
        : theme.palette.grey[900]
    }`,
  },
  actionLine: {
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
  },
  container: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    padding: theme.spacing(3),
  },
  chip: {
    margin: theme.spacing(1),
  },
  emotionContainer: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
  },
  emotionText: {
    marginLeft: "0.5rem",
  },
  iconEmotion: {
    width: "1.5rem",
  },
  love: {
    color: "#fa52d9",
  },
  happy: {
    color: "#28a745",
  },
  normal: {
    color: "#007bff",
  },
  sad: {
    color: "#ffc107",
  },
  angry: {
    color: "#dc3545",
  },
  breakLine: {
    width: "100%",
  },
});
